import React from 'react'
import { SkeletonLoader } from '@awell-health/design-system'

export const ActivityDetailLoading: React.FC = () => {
  return (
    <div className="mt-4 flex flex-col gap-2">
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <div className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <div className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
      <SkeletonLoader className="h-10 w-full" />
    </div>
  )
}
